import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Table, Tooltip, Badge } from 'antd';
import { Link } from 'react-router-dom';
import { TableWrapper } from '../styled';
import {
    UilEdit,
    UilCommentAltMessage,
    UilUserPlus,
    UilPlus,
} from '@iconscout/react-unicons';
import Heading from '../../components/heading/heading';
import { Cards } from '../../components/cards/frame/cards-frame';
import { ProjectListTitle, ProjectListAssignees, ProjectList } from '../project/style';
import { Button } from '../../components/buttons/buttons';
import { getItem } from '../../utility/localStorageControl';
import { useDispatch, useSelector } from 'react-redux';
import { notificationsDataRead } from '../../redux/Notifications/actionCreator';
import FontAwesome from 'react-fontawesome';

function ProjectLists({
    value,
    handleFunctionClick,
    handleEditFunctionProp,
    handleAssignToMeFunctionProp,
    persons,
    handleDeleteStatusNotification,
    handleCreateFromExistingTask,
}) {
    const role = getItem('role');

    const rolePathMap = {
        ADMIN: 'admin',
        TEAMLEAD: 'teamlead',
        TEAM_LEAD: 'teamlead',
        EMPLOYEE: 'employee',
        INTERN: 'intern',
    };

    const dispatch = useDispatch();
    // const personsData = useMemo(() => [...persons], [persons]);
    const personsData = useMemo(() => (Array.isArray(persons) ? persons : []), [persons]);


    const { NotificationsDeleteRes, NotificationsRes } = useSelector((state) => ({
        NotificationsRes: state.NotificationsRes.data,
        NotificationsDeleteRes: state.NotificationsDeleteRes.data,
    }));

    useEffect(() => {
        dispatch(notificationsDataRead(parseInt(getItem('userId'))));
    }, [dispatch]);

    useEffect(() => {
        if (NotificationsDeleteRes !== null && NotificationsDeleteRes.Error === false) {
            dispatch(notificationsDataRead(parseInt(getItem('userId'))));
        }
    }, [NotificationsDeleteRes, dispatch]);

    const [state, setState] = useState({
        current: 1,
        pageSize: 10,
    });

    const onHandleChange = (current, pageSize) => {
        setState((prev) => ({ ...prev, current, pageSize }));
    };

    const statusPriorityOrder = ['IN PROGRESS', 'NOT STARTED', 'DEFERRED', 'FINISHED', 'DROPPED'];
    const priorityOrder = ['HIGH', 'MEDIUM', 'LOW'];
    const roleKey = String(role || '').toUpperCase().trim();
    const basePath = rolePathMap[roleKey] || 'employee';

    const dataSource = useMemo(() => {
        const data = Array.isArray(value) ? [...value] : [];

        const rows = data.map((item) => {
            const {
                id,
                task,
                status,
                personIds,
                assignedby,
                persons: assignedPersons,
                createdon,
                deadline,
                priority,
                progressLatestUpdate,
                projectName,
            } = item;

            return {
                key: id,

                task: (
                    <ProjectListTitle>
                        <Heading as="h4">
                            <Link
                                target="_blank"
                                rel="noopener noreferrer"
                                to={`/${role === 'ADMIN' ? 'admin' : 'employee'}/project-details/${id}`}
                            >
                                {task}
                            </Link>
                            {/* <Link
                                target="_blank"
                                rel="noopener noreferrer"
                                to={`/${basePath}/project-details/${id}`}
                            >
                                {task}
                            </Link> */}
                        </Heading>
                    </ProjectListTitle>
                ),

                projectName: projectName || 'NA',
                startDate: createdon,
                deadline: deadline !== 'NA' ? deadline : 'NA',
                persons: assignedPersons,
                latestUpdatedOn: progressLatestUpdate,
                assignedby: assignedby,

                assigned: (
                    <ProjectListAssignees>
                        {personIds?.length > 0 ? (
                            <ul>
                                {assignedPersons.map((person, index) => {
                                    let imageSrc = null;
                                    try {
                                        imageSrc = `${process.env.REACT_APP_API_ENDPOINT}/public/profile/${person?.imagename}`;
                                    } catch (error) {
                                        imageSrc = null;
                                    }

                                    const avatar = imageSrc ? (
                                        <img
                                            className="img-border-radius img-dimensions"
                                            src={imageSrc}
                                            alt=""
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.parentNode.appendChild(
                                                    document.createElement('div')
                                                ).innerHTML = `<span class="ant-avatar ant-avatar-circle">
                          ${person.name[0].toUpperCase()}
                        </span>`;
                                            }}
                                        />
                                    ) : (
                                        <span className="ant-avatar ant-avatar-circle">
                                            {person.name[0].toUpperCase()}
                                        </span>
                                    );

                                    return (
                                        <Tooltip title={person?.name} key={index}>
                                            <li>
                                                {role === 'ADMIN' ? (
                                                    <Link
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        to={`/admin/employee-profile/${person?.username}/${person?.usermasterId}`}
                                                    >
                                                        <div className="cursor-style">{avatar}</div>
                                                    </Link>
                                                ) : (
                                                    <div className="cursor-style">{avatar}</div>
                                                )}
                                            </li>
                                        </Tooltip>
                                    );
                                })}
                            </ul>
                        ) : (
                            <div className="not-assigned-icon">
                                <FontAwesome
                                    name="user-circle-o"
                                    style={{ fontSize: '32px', color: 'rgba(171, 170, 170, 0.79)' }}
                                />
                            </div>
                        )}
                    </ProjectListAssignees>
                ),

                statusText: status,
                priorityText: priority,

                status: <span className={`status ${status?.toLowerCase()}`}>{status}</span>,
                priority: <span className={`status ${priority?.toLowerCase()}`}>{priority}</span>,

                actions:
                    status !== 'FINISHED' && status !== 'DROPPED' ? (
                        role === 'ADMIN' ? (
                            <div className="table-actions">
                                <>
                                    <Tooltip title="Create new task with same Project & Product">
                                        <Button
                                            key="createTaskFromExistingButton"
                                            onClick={() => handleCreateFromExistingTask(item)}
                                            className="btn-icon"
                                            type="primary"
                                            to="#"
                                            shape="circle"
                                        >
                                            <UilPlus />
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title="Manage Person(s)">
                                        <Button
                                            key="assignTaskButton"
                                            onClick={() => handleEditFunctionProp(item, false)}
                                            className="btn-icon"
                                            type="primary"
                                            to="#"
                                            shape="circle"
                                        >
                                            <UilUserPlus />
                                        </Button>
                                    </Tooltip>

                                    <Tooltip title="Edit">
                                        <Button
                                            key="editTaskButton"
                                            onClick={() => handleEditFunctionProp(item, true)}
                                            className="btn-icon"
                                            type="primary"
                                            to="#"
                                            shape="circle"
                                        >
                                            <UilEdit />
                                        </Button>
                                    </Tooltip>
                                </>
                            </div>
                        ) : assignedPersons?.filter(
                            (p) => p?.usermasterId === parseInt(getItem('userId'))
                        )?.length === 0 ? (
                            <p>Not Assigned</p>
                        ) : (
                            <p className="align-center-v justify-content-center">Assigned</p>
                        )
                    ) : (
                        <p>{status === 'FINISHED' ? 'Task Finished' : 'Task Dropped'}</p>
                    ),

                progress: (
                    <div className="d-flex justify-content-evenly">
                        <Tooltip
                            title={progressLatestUpdate === 'NA' ? 'No Progress to see' : 'View Progress'}
                        >
                            <span>
                                <Button
                                    disabled={progressLatestUpdate === 'NA'}
                                    transparented
                                    key="progressBtn"
                                    onClick={() =>
                                        handleFunctionClick(
                                            id,
                                            task,
                                            NotificationsRes?.filter(
                                                (obj) =>
                                                    obj?.taskId === id &&
                                                    parseInt(getItem('userId')) === obj?.usermasterId &&
                                                    obj?.type === 'PROGRESS'
                                            )?.length > 0,
                                            NotificationsRes
                                        )
                                    }
                                    type="primary"
                                >
                                    <UilCommentAltMessage />
                                    {NotificationsRes?.filter(
                                        (obj) =>
                                            obj?.taskId === id &&
                                            parseInt(getItem('userId')) === obj?.usermasterId &&
                                            obj?.type === 'PROGRESS'
                                    )?.length > 0 && <Badge className="m-0" dot />}
                                </Button>
                            </span>
                        </Tooltip>
                    </div>
                ),
            };
        });

        rows.sort((a, b) =>
            statusPriorityOrder.indexOf(a.statusText) -
            statusPriorityOrder.indexOf(b.statusText)
        );

        return rows;
    }, [value, role, handleCreateFromExistingTask, handleEditFunctionProp, handleFunctionClick, NotificationsRes]);

    const columns = [
        {
            title: 'Task',
            dataIndex: 'task',
            key: 'task',
            sorter: (a, b) => {
                const taskA = a?.task?.props?.children?.props?.children?.props?.children || '';
                const taskB = b?.task?.props?.children?.props?.children?.props?.children || '';
                return String(taskA).localeCompare(String(taskB));
            },
        },
        {
            title: 'Project',
            dataIndex: 'projectName',
            key: 'projectName',
            render: (text) => (text && text !== '' ? text : 'NA'),
            sorter: (a, b) => (a.projectName || '').localeCompare(b.projectName || ''),
        },
        {
            title: 'Target Date',
            dataIndex: 'deadline',
            key: 'deadline',
            sorter: (a, b) => String(a.deadline).localeCompare(String(b.deadline)),
        },
        {
            title: 'Assigned To',
            dataIndex: 'assigned',
            key: 'assigned',
            filters: Array.from(new Set(personsData?.map((i) => i?.name))).map((name) => ({
                text: name,
                value: name,
            })),
            onFilter: (val, record) =>
                record?.persons?.some((p) => p?.name === val),
        },
        {
            title: 'Assigned By',
            dataIndex: 'assignedby',
            key: 'assignedby',
            render: (text) => text || 'NA',
            filters: Array.from(new Set(dataSource.map(r => r.assignedby).filter(Boolean))).map(name => ({
                text: name,
                value: name,
            })),
            onFilter: (val, record) => record.assignedby === val,
        },

        {
            title: 'Priority',
            dataIndex: 'priority',
            key: 'priority',
            filters: priorityOrder.map((p) => ({ text: p, value: p })),
            onFilter: (val, record) => record.priorityText === val,
            sorter: (a, b) =>
                priorityOrder.indexOf(a.priorityText) - priorityOrder.indexOf(b.priorityText),
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            filters: statusPriorityOrder.map((s) => ({ text: s, value: s })),
            onFilter: (val, record) => record.statusText === val,
            sorter: (a, b) =>
                statusPriorityOrder.indexOf(a.statusText) - statusPriorityOrder.indexOf(b.statusText),
            render: (_, record) => (
                <div className="d-flex">
                    <div>{record.status}</div>
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDeleteStatusNotification(record, NotificationsRes)}
                    >
                        {NotificationsRes?.filter(
                            (obj) =>
                                obj?.taskId === record?.key &&
                                parseInt(getItem('userId')) === obj?.usermasterId &&
                                obj?.type === 'STATUS'
                        )?.length > 0 && <Badge dot />}
                    </div>
                </div>
            ),
        },

        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            align: 'center',
        },

        ...(role === 'ADMIN'
            ? [
                {
                    title: 'Progress',
                    dataIndex: 'progress',
                    key: 'progress',
                    align: 'center',
                },
            ]
            : []),

        {
            title: 'Recent Updates',
            dataIndex: 'latestUpdatedOn',
            key: 'latestUpdatedOn',
            sorter: (a, b) =>
                String(a.latestUpdatedOn).localeCompare(String(b.latestUpdatedOn)),
        },
    ];

    return (
        <Row gutter={25}>
            <Col xs={24}>
                <Cards headless>
                    <ProjectList>
                        <TableWrapper>
                            <div className="table-responsive">
                                <Table
                                    pagination={{
                                        current: state.current,
                                        pageSize: state.pageSize,
                                        total: dataSource.length,
                                        onChange: onHandleChange,
                                    }}
                                    dataSource={dataSource}
                                    columns={columns}
                                />
                            </div>
                        </TableWrapper>
                    </ProjectList>
                </Cards>
            </Col>
        </Row>
    );
}

export default ProjectLists;
